<template>
    <div class="authentication_form_box">
        <div class="scholar_top">
            <van-icon style="position: absolute; left: 10px" size="25" name="arrow-left" @click="() => $router.go(-1)" />
            <div class="my">基本信息</div>
            <div class="determine" @click="setSave">保存</div>
        </div>
        <div class="scholar_bottom">
            <van-cell-group class="cell_group_box">
                <van-cell class="upload_box" :required="true" title="Logo/头像" center>
                    <template>
                        <van-image class="upload_img" round width="37px" height="37px"
                            :src="organization.coverImg ? $global.imgUrl + organization.coverImg : require('@/assets/img/mobile-img/upload-default.png')"
                            @click="preview(organization.coverImg)" />
                        <van-uploader :max-size="1 * 1024 * 1024" :before-read="beforeRead"
                            :after-read="(file) => clzpAfterRead(file, 'coverImg')" @oversize="onOversize">
                            <van-icon class="upload_icon" name="arrow" />
                        </van-uploader>
                    </template>
                </van-cell>
                <van-cell :required="true" title="机构名称" :value="organization.name | isNull" @click="toEdit('InputEdit', {
                    objName: 'organization',
                    key: 'name',
                    label: '机构名称',
                    ruleKey: 'name',
                    disabled: true,
                })" is-link />
                <van-cell title="简介" :value="$global.matchReg(organization.outline) | isNull" @click="toEdit('InputEdit', {
                    objName: 'organization',
                    key: 'outline',
                    label: '简介',
                    type: 'textarea',
                    ruleKey: 'length100',
                })" is-link />
            </van-cell-group>
        </div>
        <TipsDialog :showDialog="changeModalShow" @dialogCancel="leavePage" @dialogConfirm="setSave"
            @clickOverlay="changeModalShow = false">
            是否保存本次修改？
        </TipsDialog>
    </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
export default {
    name: "InstitutionModification",
    components: {
        TipsDialog,
    },
    data() {
        return {
            organization: {
                coverImg: "",
                name: "",
                outline: "",
            },
            changeModalShow: false,
        }
    },
    created() {
        if (sessionStorage.getItem("organization")) {
            this.formateInfo();
        } else {
            this.getUserDetails();
        }
    },
    watch: {
        organization: {
            handler(newV) {
                sessionStorage.setItem("organization", JSON.stringify(newV))
            },
            deep: true,
        },
    },
    filters: {
        isNull(value) {
            return value !== '' && value !== '-' ? value : '未设置'
        },
    },
    methods: {
        leavePage() {
            sessionStorage.setItem("baseOrganization", JSON.stringify(this.organization));
            this.$router.go(-1);
        },
        // 获取基本信息
        async getUserDetails() {
            let { content: { orgInfo } } = await this.$apis.userServe.getOrDetails();
            let copyOrgInfo = this.$global.deepClone(this.organization)
            for (const key in orgInfo) {
                copyOrgInfo[key] = orgInfo[key]
            }
            sessionStorage.setItem("baseOrganization", JSON.stringify(copyOrgInfo));
            sessionStorage.setItem("organization", JSON.stringify(orgInfo));
            this.formateInfo();
        },
        formateInfo() {
            if (sessionStorage.getItem("organization")) {
                let organization = JSON.parse(sessionStorage.getItem("organization"))
                for (const key in organization) {
                    this.organization[key] = organization[key]
                }
            }
        },
        async setSave() {
            let basicInfoStrValidate = ["coverImg"].every(item => this.organization[item] !== '')
            if (basicInfoStrValidate) {
                const res = await this.$apis.userServe.setName({ org: this.organization });
                if (res.resultCode !== '200') {
                    Toast(data.resultDesc)
                } else {
                    Toast('保存成功')
                    sessionStorage.setItem("baseOrganization", JSON.stringify(this.organization));
                    this.$router.go(-1);
                }
            } else {
                Toast('请填写基本信息中必填字段')
            }
        },

        //校验图片的格式
        beforeRead(file) {
            if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
                Toast("仅支持JPG、JPEG、PNG格式");
                return false;
            }
            return true;
        },
        //校验上传图片大小
        onOversize(file) {
            Toast("文件大小不能超过1MB");
        },
        // 预览上传的图片
        preview(url) {
            if (url) {
                ImagePreview({
                    images: [this.$global.imgUrl + url],
                    closeable: true,
                })
            }
        },
        //照片上传事件方法
        async clzpAfterRead(file, key) {
            // 创建一个空对象实例
            let formData = new FormData();
            // 调用append()方法添加数据
            formData.append("file", file.file);
            const res = await this.$apis.myServe.uploadFileMannual(formData);
            this.organization[key] = res.data;
        },
        // 去编辑
        toEdit(path, query) {
            this.$router.push({ path, query });
        },
    },
    beforeRouteLeave(to, from, next) {
        let baseOrganization = JSON.parse(sessionStorage.getItem("baseOrganization"));
        let noChange = this.$global.equals(baseOrganization, this.organization)
        if (to.name === 'InputEdit') {
            next()
        } else if (noChange) {
            sessionStorage.removeItem("baseOrganization");
            sessionStorage.removeItem("organization");
            next()
        } else {
            this.changeModalShow = true
            next(false)
        }
    }
}
</script>

<style lang='scss' scoped>
.authentication_form_box {
    position: relative;
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .scholar_top {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        line-height: 44px;
        background: #fff;

        .my {
            font-size: 18px;
            color: #333333;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .scholar_bottom {
        margin: 22px auto;
        padding-bottom: 20px;
        width: 94%;
        height: 100%;

        .cell_group_box {
            margin-top: 12px;
            border-radius: 8px;
            overflow: hidden;

            .upload_box {
                .upload_img {
                    margin-right: 10px;
                    vertical-align: middle;
                }

                .upload_icon {
                    height: 24px;
                    font-size: 16px;
                    line-height: 24px;
                    color: #969799;
                    vertical-align: middle;
                }
            }
        }
    }
}
</style>